/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImagesTab/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'



/** @type {import('Simple/types.js').View} */
export default function ImagesTab({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/Tabs/ImagesTab"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Images"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../ActiveTab/Images'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../ActiveTab/Images'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../ActiveTab/Images'))}
 size="medium"
/>
{children}
</React.Fragment>)
}